import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Status } from '@fullyops/legacy/data';
import { User } from '@fullyops/legacy/data';
import { Priority } from '@fullyops/legacy/ui';
import {
  FieldItems,
  TemplateFormFields,
} from '../../ui-shared/form-template/form-template.component';
import { AssigneeService } from '@fullyops/shared/services/assignees.service';
import { SupportTicketResponse } from '@fullyops/legacy/data/api/types/SupportTicket';

@Component({
  selector: 'app-ticket-support-form-tracking-v2',
  templateUrl: './ticket-support-form-tracking-v2.component.html',
  styleUrls: ['./ticket-support-form-tracking-v2.component.scss'],
  standalone: false,
})
export class TicketSupportFormTrackingV2Component implements OnInit {
  @Input() isDetailPage: boolean;
  @Input() formGroupNewTicket: UntypedFormGroup;
  formFields: TemplateFormFields<any>;

  @Input() trackingFormGroup: UntypedFormGroup;
  formAssigneeFields: TemplateFormFields<any>;

  @Input() users$: BehaviorSubject<User[]>;
  @Input() statuses$: BehaviorSubject<Status[]>;
  @Input() ticket: SupportTicketResponse;
  @Output() updateTicket = new EventEmitter<any>();

  assignees$ = new BehaviorSubject<any[]>([]);
  priorities$ = new BehaviorSubject<FieldItems[]>([]);
  statusesList$ = new BehaviorSubject<any[]>([]);

  constructor(private assigneeService: AssigneeService) {}

  ngOnInit() {
    this.initAssignees();
    this.initPriorities();
    this.initFormFields();
    this.patchTicketOnChange();
    this.ifPageIsDetailPageDisableForms();

    this.statuses$
      .pipe(
        map((statuses) =>
          statuses.map((s) => ({
            ...s,
            image: `assets/svg/statuses/${s.name.toLocaleLowerCase()}.svg`,
          })),
        ),
      )
      .subscribe((x) => this.statusesList$.next(x));
  }

  ifPageIsDetailPageDisableForms() {
    if (this.isDetailPage) {
      this.trackingFormGroup.disable();
    }
  }

  patchTicketOnChange() {
    if (!this.ticket) return;

    this.trackingFormGroup.valueChanges.subscribe(() => {
      this.trackingFormGroup.markAllAsTouched();
      if (this.trackingFormGroup.get('actAt').value) {
        this.updateTicket.emit();
      }
    });
  }

  initAssignees() {
    this.users$
      .pipe(
        map((users) => {
          return this.assigneeService.getDropdownAssigneeList({
            formValue: this.ticket?.assignees || [],
            listOfUsers: users,
          });
        }),
        map((users) =>
          users.map((user) => ({
            id: user.id,
            name: `${user.firstName} ${user.lastName}`,
          })),
        ),
      )
      .subscribe((users) => {
        this.assignees$.next(users);
      });
  }

  initPriorities() {
    const pro = Object.entries(Priority).map(([key, value]) => ({
      id: key,
      name: Priority[key],
      image: `assets/svg/priorities/${value.toLocaleLowerCase()}.svg`,
    }));
    this.priorities$.next(pro);
  }

  initFormFields() {
    this.formFields = [
      {
        name: 'statusId',
        type: 'select',
        label: 'status',
        size: 6,
        items$: this.statusesList$,
        nullable: false,
        translate: true,
        dataTestId: 'status-select-cypress',
      },
      {
        name: 'priority',
        type: 'select',
        label: 'priority',
        size: 6,
        items$: this.priorities$,
        nullable: false,
        translate: true,
        dataTestId: 'priority-test',
      },
      { name: 'actAt', type: 'fulldate', label: 'chooseDate', size: 12 },
      {
        name: 'technicianIds',
        type: 'multiple-select',
        label: 'assignee',
        size: 12,
        items$: this.assignees$,
        translate: false,
        dataTestId: 'technicianIds-test',
      },
    ];
  }
}
